import { firebaseDb, ServerTimestamp } from '../firebase/'
import { addNotification } from './notification'
import history from '../history'

export const loadPlans = () => (
  (dispatch, getState) => {
    firebaseDb.collection('plans').get()
    .then(snapshot => {
      dispatch({
        type: 'LOAD_PLANS',
        snapshot
      })
      dispatch(loadPlanData(getState().plans.selectedPlanId))
    })
    .catch(err => {
      console.log("Error getting document:", err)
    })
  }
)
export const loadPlanData = planId => (
  dispatch => {
    firebaseDb.collection('plans').doc(planId).collection('data').get()
    .then(snapshot => {
      dispatch({
        type: 'LOAD_PLAN_DATA',
        planId,
        snapshot
      })
    })
    .catch(err => {
      console.log("Error getting document:", err)
    })
  }
)
export const updatePlan = values => (
  dispatch => {
    firebaseDb.collection('plans').doc(values.planId).collection('data').doc(values.team).set({
      plan: values.plan,
      updated: ServerTimestamp
    })
    .then(() => {
      dispatch(loadPlanData(values.planId))
      dispatch(addNotification("更新しました", "success"))
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("更新に失敗しました", "error"))
    })
  }
)

export const changePlanId = planId => (
  (dispatch, getState)=> {
    dispatch(changePlanningFormInitStatus(true)).then(() => {
      dispatch({
        type: 'CHANGE_PLAN_ID',
        planId
      })
      if(!getState().plans.planData[planId]){
        dispatch(loadPlanData(planId))
      }
    })
  }
)
export const changePlanningTeam = teamId => (
  dispatch => {
    dispatch({
      type: 'CHANGE_PLANNING_TEAM',
      teamId
    })
    teamId === 'all'?
      history.push('/plan')
    :
      history.push('/plan/' + teamId)
  }
)
export const planningFormInitialized = () => (
  dispatch => {
    dispatch(changePlanningFormInitStatus(false))
  }
)
export const changePlanningFormInitStatus = status => 
  dispatch => Promise.resolve().then(() => {
    dispatch({
      type: 'CHANGE_PLANNING_FORM_INIT_STATUS',
      status
    })
  }
)



// WEBPACK FOOTER //
// ./src/actions/plans.js